import { render } from "./verify-email.vue?vue&type=template&id=80f66894"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./verify-email.vue?vue&type=style&index=0&id=80f66894&lang=module.scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__